package horcrux.frontend.common.views.collections.importdocuments

import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.collections.collectiondialogs.CollectionDetailsState
import horcrux.frontend.common.views.collections.collectiondialogs.EditCollectionSettings
import horcrux.frontend.common.views.components.containers.DialogAction
import horcrux.frontend.common.views.components.containers.DialogView
import mui.material.AlertColor
import mui.material.Button
import mui.material.DialogContent
import mui.material.DialogTitle
import mui.system.sx
import react.FC
import react.Props
import web.cssom.pt

external interface EditCollectionDetailsDialogProps : Props {
    var collectionDetailsState: CollectionDetailsState
    var globalAppState: GlobalAppState
}

val EditCollectionDetailsDialog = FC<EditCollectionDetailsDialogProps> { props ->
    val showDialogState = BooleanState()
    val title = "Edit Collection Details"

    Button {
        +"Edit Collection Details"
        this.fullWidth = true
        this.onClick = {
            props.collectionDetailsState.defaultCollectionNameMaybeState.get()?.let {
                showDialogState.setTrue()
            } ?: run {
                props.globalAppState.updateBanner(AlertColor.error, "Please add at least one document")
            }

        }
    }

    DialogView {
        this.title = title
        this.showDialogState = showDialogState
        this.dialogActionsMaybe = listOf(
            DialogAction("Reset") { _, _ ->
                props.collectionDetailsState.resetCollectionName()
            },
            DialogAction("OK") { showDialogState, _ ->
                if (!props.collectionDetailsState.isCollectionNameInvalid) {
                    showDialogState.setFalse()
                } else {
                    props.globalAppState.updateBanner(AlertColor.error, "Please make sure input values are valid")
                }
            }
        )
        DialogTitle { +title }
        DialogContent {
            this.sx {
                this.marginRight = 10.pt
                this.marginLeft = 10.pt
            }
            EditCollectionSettings {
                this.collectionDetailsState = props.collectionDetailsState
            }
        }
    }
}
